<div dir="ltr" style=" background-color: white;border:none ;padding-bottom: 0.1%;">
    <h1 class="hr" translate>Sites Utiles</h1>
</div>
<div class="st-div">
    <owl-carousel [carouselClasses]="['owl-theme', 'sliding']" [options]="slideOptions">
        <div *ngFor="let image of images" class="item">
            <div>
                <a (click)="goToUrl(image.url)"
                ><img [src]="image.src" height="50%" width="20%"></a>

            </div>
        </div>
    </owl-carousel>
</div>
